import { FC } from 'react';
import styled from 'styled-components';
import { COLOURS, media } from '@belong/themes';
import { Column, Columns, Section } from '@belong/ui-components';
import { ISectionCoverageMap } from './model';

const StyledSection = styled(Section)`
  & + .contentSection {
    border-top: 4rem solid rgba(0, 0, 0, 0);
    ${media('md')`
      border-top-width: 4.8rem;
    `}
  }
`;

const Wrapper = styled.div`
  position: relative;
  padding: 2.4rem;
  box-shadow: 0 0.1rem 0.4rem rgba(0, 0, 0, 0.15);
  background-color: ${COLOURS.WHITE};
  ${media('md')`
    padding: 3.2rem;
  `}

  iframe {
    width: 100%;
    height: 970px;
    border: 0;
    ${media('sm')`
      height: 930px;
    `}
    ${media('md')`
      height: 830px;
    `}
  }
`;

export const SectionCoverageMap: FC<ISectionCoverageMap> = ({
  identifier,
  sectionStyles,
  title,
  coverageMapIframeUrl
}: ISectionCoverageMap) => {
  // NOTE: There was originally a condition here called `isMounted` which
  // prevented the iframe below from rendering until the component mounted. It
  // caused issues and it was unclear why the condition was there in the first
  // place so it's now been removed. This notice is in place in case an issue
  // arises here in the future.
  // See: https://bitbucket.org/belongadmin/belong-web/commits/4d01c7f
  // See: https://belongranda.atlassian.net/browse/BT-26804

  /*
   * NOTE: The Map only loads when the domain is whitelisted in the Telstra side
   * Currently, these envs are whitelisted:
   * https://dev.belongtest.com.au
   * https://at.belongtest.com.au
   * https://sit.belongtest.com.au
   * https://preprod.belongtest.com.au
   * https://preview.belongtest.com.au
   *
   * And prod
   * https://www.belong.blue
   * https://www.belong.com.au
   * (including www. from telstra team)
   *
   *
   * To update the URL, please refrence below confluence page:
   * https://belongranda.atlassian.net/wiki/spaces/BEL/pages/697631174/WME+-+How+to+engage+Telstra+Wholesale+or+Ericsson
   *
   */

  return (
    <StyledSection
      className="contentSection"
      data-identifier={identifier}
      data-testid="section-coverage-map"
      {...sectionStyles}
    >
      <Columns alignX="center">
        <Column width={{ xl: '5/6' }}>
          <Wrapper>
            <iframe title={title} allow="geolocation" src={coverageMapIframeUrl} />
          </Wrapper>
        </Column>
      </Columns>
    </StyledSection>
  );
};

export default SectionCoverageMap;
